import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpBaseService } from './http-services/http-base';

/**
 * Read-only client for the Harmonized Storage API (`api/HarmonizedStorage`).
 *
 * Mirrors the listing/download surface of {@link StorageService} so the shared
 * `FolderGridComponent` can swap its listing source, but is rooted at
 * `PDP/Harmonized/` and exposes no upload/folder/promote operations.
 */
@Injectable({ providedIn: 'root' })
export class HarmonizedStorageService {
  constructor(private httpService: HttpBaseService) {}

  /**
   * GET /api/HarmonizedStorage/list?path=<rel>&c=<token>
   *
   * Lists folders and files under the harmonized prefix at `path`. The
   * continuation token is optional; the backend currently drains all pages
   * server-side so it is typically returned as null. Passing it keeps the
   * client forward-compatible if incremental paging is enabled later.
   */
  getList(path: string, continuationToken: string = ''): Observable<any> {
    const c = continuationToken
      ? `&c=${encodeURIComponent(continuationToken)}`
      : '';
    return this.httpService.get<any>(`harmonizedstorage/list?path=${path}${c}`);
  }

  /**
   * GET /api/HarmonizedStorage/download?path=<rel>
   *
   * Resolves ready-to-GET presigned URLs for the file(s) under `path`,
   * recursively expanding partition folders (year → month → day → files).
   */
  downloadList(path: string): Observable<any> {
    return this.httpService.get<any>(`harmonizedstorage/download?path=${path}`);
  }
}
